// @file Pinia store for the starting state of the surface
import { blankState } from '@@/vuexstore/surface'
import type { SurfaceState } from '@@/vuexstore/surface/types'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useSurfaceStartingStateStore = defineStore('surfaceStartingState', () => {
  const startingState = ref<SurfaceState>({ ...blankState() })

  const arvoConfig = computed(() => startingState.value.arvoConfig)

  function intializeState(state: SurfaceState): void {
    startingState.value = state
  }

  return {
    startingState,
    arvoConfig,
    intializeState,
  }
})
